/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { Input, message, Select, Form, Row, Col, Button, Popconfirm } from 'antd';

import { Main } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { DataService } from '../../../config/dataService/dataService';
import './form.css'
import { Cards } from '../../../components/cards/frame/cards-frame';

const { Option } = Select;

function DataTable() {
  const [form] = Form.useForm();
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(false);

  const fetchData = async () => {
    try {
      setBusy(true)
      const response = await DataService.post('/c-validity/query');
      const { data } = response.data;
      // setTableData(data);
      // setTotalRows(total);
      form.setFieldsValue({
        ...data
      })
      setBusy(false)
    } catch (error) {
      message.error(`Error fetching table data:  ${error.message}`)
      setBusy(false)
    }
  };

  useEffect(() => {
    fetchData();
    if (reload) setReload(false)
  }, [reload]);

  const handleSubmit = async (values) => {
    try {
      let canContinue = false;
      try {
        const result = await form.validateFields();
        if (result) canContinue = true;
      } catch (error) {
        return
      }
      if (!canContinue) return;

      setBusy(true);
      const payload = form.getFieldsValue();

      const endpoint = '/c-validity/create-update';
      const response = await DataService.post(endpoint, payload);

      if (response.data.status) {
        message.success(response.data.message);
      } else {
        message.error(`Error: ${response.data.message}`)
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      message.error(`Error submitting data: ${error.message}`)
    }
  };


  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Cards Validity" routes={[]} />
      <Main>
        <Cards title="Cards Validity Details" border size="default">

          <Form
            layout="horizontal"
            form={form}
            onFinish={handleSubmit}
            disabled={busy}
            labelCol={{ span: 6 }} // Adjust label width
            wrapperCol={{ span: 16 }} // Adjust input width
          >


            <Form.Item
              name="validity_unit"
              label="Validity Unit"
              rules={[
                { type: 'number', required: true, message: 'Please input the validity unit!' },
              ]}
            >
              <Select className='h-10'>
                <Option value={1}>Months</Option>
                <Option value={2}>Years</Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="validity_amount"
              label="Validity Amount"
              rules={[
                {
                  type: 'integer', required: true, message: 'Please input the validity amount!', validator: (_, value) => {
                    const cnicPattern = /^(?!(?:^[-+]?[0.]+(?:[Ee]|$)))(?!(?:^-))(?:(?:[+-]?)(?=[0123456789.])(?:(?:(?:[0123456789]+)(?:(?:[.])(?:[0123456789]*))?|(?:(?:[.])(?:[0123456789]+))))(?:(?:[Ee])(?:(?:[+-]?)(?:[0123456789]+))|))$/;
                    if (!value) {
                      return Promise.reject(new Error('Validity amount is required!'));
                    }
                    if (!cnicPattern.test(value)) {
                      return Promise.reject(new Error('Validity amount must be a positive number!'));
                    }
                    if (Number(value) < 1) {
                      return Promise.reject(new Error('Validity amount must be a positive number!'));
                    }

                    return Promise.resolve();
                  }
                },
              ]}
            >
              <Input placeholder="Enter Address" />
            </Form.Item>

          </Form>
          <div className="flex justify-end mr-[90px]">
            <Popconfirm
              title='Are you sure to update record ?'
              onConfirm={handleSubmit}
              okText="Yes"
              cancelText="No"
            >
              <Button type="primary"  disabled={busy} loading={busy}>
                Update Data
              </Button>
            </Popconfirm>

          </div>
        </Cards>
      </Main >
    </>
  );
}

export default DataTable;
